import React from "react";
import './Home.css';
import LeftSection from './LeftSection';
import SearchbarSection from './SearchbarSection';
import RightSection from './RightSection';
import NewArrival from './NewArrival';
import SoldCar from './SoldCar';
import DealerStock from './DealerStock';
import TestMiddleBanner from './TestMiddleBanner';
import MiddleBanner from './MiddleBanner';
import CarAnimation from './CarAnimation';
import WorldMapSection from './WorldMapSection';
import SearchVehicles from './SearchVehicles';
import CarReview from './CarReview';
import ReviewCarousel from './ReviewCarousel';

import 'bootstrap/dist/css/bootstrap.min.css';

const Home = () => {
  console.log("Home rendered");
  
  return (
    <div className="container-fluid p-0">
      <div className="row no-gutters">
        <div className="col-lg-2 col-md-3 col-12 leftcol">
          <LeftSection />
        </div>
        <div className="col-lg-8 col-md-9 col-12 middlecol">
          <SearchbarSection />
          <TestMiddleBanner />
          <SearchVehicles />
          <NewArrival />
          <DealerStock />
          <SoldCar />          
        </div>
        <div className="col-lg-2 col-12 rightcol">
          <RightSection />
        </div>
      </div>
      <div className="row no-gutters">
        <div className="col-12">          
          <WorldMapSection />
          <CarReview />
          <ReviewCarousel />
        </div>
      </div>
    </div>
  );
};

export default Home;